<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/about/board-directors',
    'fr-CA': '/a-propos-kpt/conseil-administration'
  }
})

useHead({
  title: t('navigation.boardDirectors.metatitle'),
  meta: [{ name: 'description', content: t('navigation.boardDirectors.metadescription') }]
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('about-about')">{{ $t('navigation.about.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.boardDirectors.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.boardDirectors.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuAbout />
        <div class="contenu right">
          <div class="">
            <div v-if="$i18n.locale == 'en-CA'">
              <h2>Board of Directors of KP Tissue Inc.</h2>
              <p>The KP Tissue Inc. Board (the “Board”) consists of four directors, three of the directors are independent. Under NI 52-110, an “independent” director is one who is free from any direct or indirect relationship, which could, in the view of the Board, be reasonably expected to interfere with a director’s independent judgment.</p>
            </div>
            <div v-if="$i18n.locale == 'fr-CA'">
              <h2>Conseil d’administration de Papiers Tissu KP inc.</h2>
              <p>Le conseil d’administration de Papiers Tissu KP inc. (le « conseil ») est composé de quatre administrateurs, dont trois sont indépendants. Selon le Règlement 52-110, un administrateur « indépendant » est un administrateur qui est libre de toute relation directe ou indirecte dont on pourrait raisonnablement s’attendre, selon le Conseil, à ce qu’elle nuise à l’indépendance du jugement d’un administrateur.</p>
            </div>
            <board-directions :title="$t('boardDirectors.KP.James-Hardy.name')"
                              :text="$t('boardDirectors.KP.James-Hardy.text')" />
            <board-directions :title="$t('boardDirectors.KP.John-Wright.name')"
                              :text="$t('boardDirectors.KP.John-Wright.text')" />
            <board-directions :title="$t('boardDirectors.KP.Francois-Vimard.name')"
                              :text="$t('boardDirectors.KP.Francois-Vimard.text')" />
            <board-directions :title="$t('boardDirectors.KP.Sarah-Kruger.name')"
                              :text="$t('boardDirectors.KP.Sarah-Kruger.text')" />
            <div v-if="$i18n.locale == 'en-CA'">
              <h3>Additional notes</h3>
              <ul>
                <li>All four Directors of KP Tissue Inc. are also members of the nine-member Board of Directors of Kruger Products Inc.</li>
              </ul>
              <h2>Board of Directors of Kruger Products Inc.</h2>
            </div>
            <div v-if="$i18n.locale == 'fr-CA'">
              <h3>Renseignements supplémentaires</h3>
              <ul>
                <li>Les quatre administrateurs de Papiers Tissu KP inc. sont également membres du conseil d’administration de Produits Kruger inc., lequel est composé de neuf personnes.</li>
              </ul>
              <h2>Conseil d’administration de Produits Kruger Inc.</h2>
            </div>
            <board-directions :title="$t('boardDirectors.Kruger.Joseph-Kruger-II.name')"
                              :text="$t('boardDirectors.Kruger.Joseph-Kruger-II.text')" />
            <board-directions :title="$t('boardDirectors.Kruger.Gene-Kruger.name')"
                              :text="$t('boardDirectors.Kruger.Gene-Kruger.text')" />
            <board-directions :title="$t('boardDirectors.Kruger.David-Spraley.name')"
                              :text="$t('boardDirectors.Kruger.David-Spraley.text')" />
            <board-directions :title="$t('boardDirectors.Kruger.James-Hardy.name')"
                              :text="$t('boardDirectors.Kruger.James-Hardy.text')" />
            <board-directions :title="$t('boardDirectors.Kruger.David-Angel.name')"
                              :text="$t('boardDirectors.Kruger.David-Angel.text')" />
            <board-directions :title="$t('boardDirectors.Kruger.Dino-Bianco.name')"
                              :text="$t('boardDirectors.Kruger.Dino-Bianco.text')" />
            <board-directions :title="$t('boardDirectors.Kruger.Sarah-Kruger.name')"
                              :text="$t('boardDirectors.Kruger.Sarah-Kruger.text')" />
            <board-directions :title="$t('boardDirectors.Kruger.Francois-Vimard.name')"
                              :text="$t('boardDirectors.Kruger.Francois-Vimard.text')" />
            <board-directions :title="$t('boardDirectors.Kruger.John-Wright.name')"
                              :text="$t('boardDirectors.Kruger.John-Wright.text')" />
            <board-directions :title="$t('boardDirectors.Kruger.Francois-Thibault.name')"
                              :text="$t('boardDirectors.Kruger.Francois-Thibault.text')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
